import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../store/store';
import { queryParams } from '../../utils/query-string';
import { IListResponse } from '../../configs/constants';
import { IParams, IResources } from '../../modules/Resources/resources';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 2 });

export const resourceDropdownApi = createApi({
  reducerPath: 'resourceDropdownApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: ['resourceDropdownApi'],
  endpoints: (builder) => ({
    getResources: builder.query<IListResponse<IResources>, { page: number; pageSize: number }>({
      query: ({ page, pageSize }) => {
        const params: IParams = {
          take: pageSize,
          skip: (page - 1) * pageSize,
        };
        return {
          url: `resources?${queryParams(params)}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useGetResourcesQuery } = resourceDropdownApi;
